import { FC, useEffect, useRef, useState } from 'react';
import { ClassExitSlip } from '../../../custom-hooks/useExitSlipChartValues';
import { MenuItem } from 'primereact/menuitem';
import { Button } from 'primereact/button';
import { UserClass } from './ExitSlipSnapshotCardBody';
import { getUnfinishedStudents } from '../../../businessLogicService/exitSlipSnapshotHelper';
import { TieredMenu } from 'primereact/tieredmenu';
import { Toast } from 'primereact/toast';

interface Props {
  exitSlipValues: ClassExitSlip;
  dateExitSlip: Date;
}

const ExitSlipUnfinishedStudent: FC<Props> = ({ exitSlipValues, dateExitSlip }) => {
  const menu = useRef<TieredMenu>(null);
  const toast = useRef<Toast>(null);

  const [unfinishedStudents, setUnfinishedStudent] = useState<UserClass[]>([]);

  const handleCopy = async () => {
    try {
      const userNamestoString: string | undefined = unfinishedStudents
        ?.map(user => {
          return user.fullName;
        })
        .join(', ');
      if (userNamestoString) {
        await navigator.clipboard.writeText(userNamestoString);
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Users have been copied to clipboard!',
          life: 3000,
        });
      }
    } catch (_error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Users have not been copied to clipboard',
        life: 3000,
      });
    }
  };

  const items = [
    {
      label: 'Copy list of students',
      icon: 'nc_icon-nc_copy icon-sm',
      template: (item: MenuItem) => (
        <Button
          icon={`${item.icon}`}
          label={`${item.label}`}
          onClick={handleCopy}
          className="nc_metergroup-button"
          style={{ width: '100%' }}
        />
      ),
    },
    ...unfinishedStudents.map(el => ({
      label: el.fullName ?? '',
      className: 'ph-no-capture',
    })),
  ];

  useEffect(() => {
    setUnfinishedStudent(getUnfinishedStudents(exitSlipValues, dateExitSlip));
  }, [exitSlipValues]);

  return (
    <>
      <TieredMenu model={items} popup ref={menu} breakpoint="767px" />
      <Toast ref={toast} position="top-right" appendTo={document.body} />
      <div className="tw-flex tw-self-center tw-pb-4">
        <div
          className="tw-border-solid tw-border-neutral-100 tw-rounded-2xl tw-border-2 tw-flex tw-justify-evenly tw-items-center tw-p-2 tw-cursor-pointer"
          onClick={e => menu?.current?.toggle(e)}
        >
          <span className={`pi pi-exclamation-triangle tw-mr-2`} style={{ color: '#FDB814' }}></span>
          <span
            className="tw-text-base tw-font-semibold"
            style={{ fontFamily: 'Poppins', color: 'rgba(18, 89, 251, 1)' }}
          >
            {unfinishedStudents.length} still incomplete
          </span>
        </div>
      </div>
    </>
  );
};

export default ExitSlipUnfinishedStudent;
